import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAgents = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10 3a2 2 0 1 1 4 0v1h-4V3Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.75 15a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75H10v-2H8.75ZM13 15v2h-2v-2h2Zm1 0h1.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H14v-2Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6 5a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h3.5a2 2 0 0 0-2 2h9a2 2 0 0 0-2-2H18a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H6Zm12 2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcAgents");

export { IcAgents };
//# sourceMappingURL=ic-agents.js.map
